
import Base from '@/shared/app/ui/Base.vue';
import type CSS from 'csstype';
import Component from 'vue-class-component';

@Component
export default class WaitingTime extends Base {
  get waitingTime(): number {
    const data = this.dataset(this.datasetName)[this.keyName];
    return Number(data) || 0;
  }

  get plurialSuffix(): string {
    return this.waitingTime < 2 ? '' : 's';
  }

  get backgroundColor(): string {
    const time = this.waitingTime;
    if (time < 15) return '#4CAF50'; 
    if (time < 30) return '#FF9800'; 
    return '#F44336';              
  }

  get contentStyle(): CSS.Properties {
    const style: CSS.Properties = {
      fontSize: '2rem',
      fontFamily: 'inherit',
      fontWeight: 'normal',
      color: 'white',
      backgroundColor: this.backgroundColor,
      borderRadius: '1rem',
    };

    if (this.config.fontSize) style.fontSize = this.config.fontSize.toString();
    if (this.config.fontFamily)
      style.fontFamily = this.config.fontFamily.toString();
    if (this.config.fontWeight)
      style.fontWeight = this.config.fontWeight.toString();
    if (this.config.padding) style.padding = this.config.padding.toString();
    if (this.config.borderRadius)
      style.borderRadius = this.config.borderRadius.toString();
    return style;
  }

  get containerStyle(): CSS.Properties {
    const style: CSS.Properties = {
      margin: '0rem 2rem 2rem',
    };
    if (this.config.margin) style.margin = this.config.margin.toString();
    return style;
  }

  get textStyle(): CSS.Properties {
    const style: CSS.Properties = {
      fontSize: '2rem',
      margin: '1.6rem 0',
    };
    
    if (this.config.fontSize) style.fontSize = this.config.fontSize.toString();
    if (this.config.margin) style.margin = this.config.margin.toString();
    return style;
  }

  get datasetName() {
    return this.config.datasetName?.toString() || 'data';
  }

  get keyName() {
    return this.config.keyName?.toString() || 'waiting_time';
  }
}
